<template>
	<div style="font-family:仿宋; color:#003">
		<table align="center" width="603" border="1" cellspacing="0" cellpadding="0" style="仿宋">
			<caption style="font-weight:bold;font-family:方正小标宋简体">
				<p style="font-size:24px"> <strong style=" font-weight:bold">日照市{{ area }}残疾儿童康复救助申请审核转介表</strong></p>
			</caption>
			<tr>
				<th width="115" height="46" scope="col" style="font-family:仿宋">姓 名</th>
				<th width="85" scope="col">{{ detail.child_name }}</th>
				<th width="64" scope="col" style=" font-family:仿宋">性别</th>
				<th width="72" scope="col">{{ sex }}</th>
				<th width="51" scope="col" style=" font-family:仿宋">民族</th>
				<th width="96" scope="col">{{ minzu }}</th>
				<th width="104" rowspan="3" scope="col">
					<img style="width: 104px;min-height: 140px;" :src="avatar" />
				</th>
			</tr>
			<tr align="center">
				<td width="115" height="48" scope="col" style=" font-family:仿宋">出生年月</td>
				<td>{{ birth }}</td>
				<td style=" font-family:仿宋">监护人姓名</td>
				<td>{{ biao.jh_name }}</td>
				<td style=" font-family:仿宋">联系方式</td>
				<td>{{ biao.phone }}</td>
			</tr>
			<tr align="center" style=" font-family:仿宋">
				<td height="51">身份证号</td>
				<td colspan="2">{{ biao.idcard }}</td>
				<td colspan="2">残疾人证号<br />
					（持证必填）</td>
				<td >{{ biao.cjcard_id }}</td>
			</tr>
			<tr>
				<td height="53" align="center" style=" font-family:仿宋">家庭住址</td>
				<td colspan="6" style=" font-family:仿宋">&nbsp;{{ address }}</td>
			</tr>
			<tr>
				<td height="67" align="center" style=" font-family:仿宋">享受医疗保险情况</td>
				<td colspan="6">&nbsp;&nbsp;&nbsp;{{ biao.yibao }}</td>
			</tr>
			<tr>
				<td height="76" rowspan="2" align="center" style=" font-family:仿宋">申请救助残疾儿童基本情况</td>
				<td height="89" colspan="6">经 <span class="dibian"><span v-if="zd_org.length!=0" class="dibian">{{zd_org}}</span><span v-else class="dibian">&nbsp;&nbsp;&nbsp;</span></span> （专业医疗机构）诊断为： <span v-if="zd_org1.length!=0" class="dibian">{{zd_org1}}</span><span v-else class="dibian">&nbsp;&nbsp;&nbsp;</span>（ 视力 听力 言语 肢体 智力 精神）功能障碍、孤独症系谱障碍、 其他，次要障碍为  <span v-if="zd_org4.length!=0" class="dibian">{{zd_org4}}</span><span v-else class="dibian">&nbsp;&nbsp;&nbsp;</span>  。</td>
			</tr>
			<tr style=" font-family:仿宋">
				<td height="85" colspan="6">经监护人申请，按照国家《残疾人分类和分级》标准，评定为 <span v-if="zd_org2.length!=0" class="dibian">{{zd_org2}}</span><span v-else class="dibian">&nbsp;&nbsp;&nbsp;</span> 残疾人，残疾等级 <span v-if="zd_org3.length!=0" class="dibian">{{zd_org3}}</span> <span v-else class="dibian">&nbsp;&nbsp;&nbsp;</span> 级(7岁以上必填)</td>
			</tr>
			<tr style=" font-family:仿宋">
				<td height="74" align="center">监护人提出的申请</td>
				<td colspan="6">
					<p>申请到<span style="text-decoration: underline;text-decoration-thickness:1px">{{ biao.hosp }}</span>康复</p>
					<p align="center">&nbsp;&nbsp;&nbsp;&nbsp;监护人签字&nbsp;&nbsp;{{ biao.jh_name }}&nbsp;&nbsp;&nbsp;
						{{ shenqd[0] }}年 {{ shenqd[1] }}月 {{ shenqd[2] }}日 </p>
				</td>
			</tr>
			<tr>
				<td height="110" align="center">审核依据</td>
				<td colspan="6">
					
				</td>
			</tr>
			<tr>
				<td height="232" align="center">区县残联审批和转介意见</td>
				<td colspan="6" style="padding: 0px 5px;"> &nbsp;&nbsp;
					<p>&nbsp; 经审核，同意将儿童转介到<span
							style="text-decoration: underline;text-decoration-thickness:1px">{{ biao.hosp }}</span>（机构）接收康复救助补助资金按相关规定拨付。
					</p>
					<p> &nbsp;&nbsp; 救助方式： {{ biao.type }}<br>
						&nbsp;&nbsp; &nbsp;&nbsp; &nbsp; </p>
					<p> &nbsp;&nbsp; 审核人：{{ detail.admin_name }} &nbsp; &nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
						&nbsp;&nbsp; &nbsp;&nbsp; &nbsp;（盖章）
					</p>
					<p align="right">{{ admindate[0] }}年{{ admindate[1] }}月{{ admindate[2] }}日</p>
				</td>
			</tr>
		</table>
		<p align="center" style=" font-size:14px margin-left:10px">注:本表为电子表的导出表，具有相同效力。</p>
	</div>
</template>

<script>
export default {
	data() {
		return {
			cjcard:'',
			detail: {},
			biao: {},
			minzu:'汉族',
			zd_org:'',
			zd_org1:'',
			zd_org2:'',
			zd_org3:'',
			zd_org4:''
		}
	},
	methods: {
		chuli(){
			if(this.biao.mz_org_jieguo&&this.biao.mz_org_jieguo.length!=0){
				this.minzu=this.biao.mz_org_jieguo[0].minzu
				this.zd_org = this.biao.mz_org_jieguo[0].zd_org
				this.zd_org2=this.biao.mz_org_jieguo[0].zd_org2
				this.zd_org3=this.biao.mz_org_jieguo[0].zd_org3
			}
			if(this.biao.cjtypes.length!=0){
				for(let a =0;a<this.biao.cjtypes.length;a++){
					if(a==0){
						this.zd_org1=this.biao.cjtypes[a]
					}else if(a>0){
						this.zd_org4+=this.biao.cjtypes[a]
					}
				}
			}
		},
		async test() {
			let y = await axios.get(this.$urls + "mubiao_y/test2", {
				params: {
					id: this.biao.idcard
				},headers: {
					"token": this.teatoken
				}
			});
			if(y==false){
				if(this.biao.cjcard_id.length!=0){
					this.cjcard = this.biao.cjcard_id
				}
			}else{
				if(y.data.cjcard.cj_num==undefined||y.data.cjcard.cj_num.length==0){
					this.cjcard = this.biao.cjcard_id
				}else{
					this.cjcard = y.data.cjcard.cj_num
				}
			}
				this.cjcard = this.biao.cjcard_id
			
		}
	},
	computed: {
		teatoken(){
			return window.localStorage.getItem("tea_token");
		},
		avatar() {
			if (!this.biao.avatar || !this.biao.avatar[0]) {
				return '';
			}
			return this.$url + this.biao.avatar[0].path;
		},
		sex() {
			var num = this.biao.idcard.charAt(16);
			return num % 2 == 0 ? "女" : "男";
		},
		birth() {
			var num = this.biao.idcard.substr(6, 8);
			num = num.substr(0, 4) + "." + num.substr(4, 2) + "." + num.substr(6, 2);
			return num;
		},
		shenqd() {
			let detail = this.detail.ins_date;
			detail = detail.split(" ")[0];
			detail = detail.split("/");
			return detail;
		},
		admindate() {
			let detail = this.detail.shenhe_date;
			detail = detail.split(" ")[0];
			detail = detail.split("/");
			return detail;
		},
		zhengming() {
			if (!this.biao.yixuezhengming || !this.biao.yixuezhengming[0]) {
				return '';
			}
			return this.$url + this.biao.yixuezhengming[0].path;
		},
		area() {
			let str = "";
			if (!this.biao.huji_json || !this.biao.xianju_json) {
				return str;
			}
			if (this.biao.huji_json[0].name === this.biao.xianju_json[0].name) {

				str = this.biao.huji_json[0].name;
				return str;
			} else {
				str = this.biao.xianju_json[0].name;
				return str;
			}
		},
		address() {
			let str = "";
			if (!this.biao.huji_json || !this.biao.xianju_json) {
				return str;
			}
			if (this.biao.huji_json[0].name === this.biao.xianju_json[0].name) {

				this.biao.huji_json.map(p => {
					str += p.name
				});
				return str + this.biao.huji_address;
			} else {
				this.biao.xianju_json.map(p => {
					str += p.name
				});
				return str + this.biao.xianju_address;
			}
		}
	},
	created() {
		let shuju = window.localStorage.getItem("kf");
		shuju = JSON.parse(shuju);
		this.detail = shuju.detail;
		this.biao = shuju.biao;
		this.chuli();
		this.test();
	}
}
</script>

<style>
	.dibian{
		text-decoration: underline;
		text-decoration-thickness:1px
	}
</style>
